import { motion } from "framer-motion";
import { springPresets, staggerContainer, staggerItem } from "@/lib/motion";

const ACTIVITIES = [
  { emoji: "🎭", title: "Tiyatro Gösterileri", desc: "Okullar 23 Nisan temalı oyunlar sahneliyor" },
  { emoji: "🎵", title: "Şiir & Şarkılar", desc: "Milli marşlar ve bayram türküleri seslendiriliyor" },
  { emoji: "🎨", title: "Resim Yarışmaları", desc: "Çocuklar Atatürk ve bayramı resme yansıtıyor" },
  { emoji: "🏃", title: "Spor Etkinlikleri", desc: "Atletizm gösterileri ve koşu yarışları düzenleniyor" },
  { emoji: "🌸", title: "Çiçek Törenleri", desc: "Anıtlara çiçek bırakılarak saygı gösterileniyor" },
  { emoji: "🎪", title: "Şenlik & Eğlence", desc: "Köy alanları ve parklar çocuk şenliğine dönüşüyor" },
];

export function HowToCelebrate() {
  return (
    <section className="py-12 px-4 bg-secondary/20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-primary mb-2" style={{ fontFamily: "'Merriweather', serif" }}>
            🎊 Nasıl Kutlanır?
          </h2>
          <p className="text-muted-foreground">Türkiye genelinde coşkulu kutlamalar</p>
          <div className="w-24 h-1 bg-primary mx-auto mt-3 rounded-full" />
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-2 sm:grid-cols-3 gap-4"
        >
          {ACTIVITIES.map((act, i) => (
            <motion.div
              key={i}
              variants={staggerItem}
              whileHover={{ scale: 1.04, y: -2 }}
              transition={springPresets.snappy}
              className="bg-card border border-border rounded-xl p-5 text-center cursor-default"
              style={{ boxShadow: "0 4px 12px -4px oklch(0.48 0.24 12 / 0.08)" }}
            >
              <div className="text-3xl mb-2">{act.emoji}</div>
              <h3 className="font-bold text-foreground text-sm mb-1">{act.title}</h3>
              <p className="text-muted-foreground text-xs leading-relaxed">{act.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
